function c(n) {
  const e = n.trim();
  if (!e) return "Unknown error";
  if (/dial tcp/i.test(e) || /i\/o timeout/i.test(e) || /connection refused/i.test(e) || /connection reset/i.test(e) || /no such host/i.test(e) || /temporarily unreachable/i.test(e) || /opencode/i.test(e) || /h9-saas-opencode/i.test(e) || /:\s*4096\b/.test(e))
    return "AI assistant is temporarily unreachable. Live updates will resume automatically. Please try again in a moment.";
  const a = e.match(/^(send failed|upstream stream failed|abort failed|delete failed):\s*/i), r = a ? `${a[1]}: ` : "", s = a ? e.slice(a[0].length).trim() : e;
  if (s.startsWith("{"))
    try {
      const t = JSON.parse(s), i = t?.data?.message ?? t?.message ?? (t?.name && t.name !== "UnknownError" ? t.name : void 0);
      if (i) {
        const o = t?.data?.ref ? ` (${t.data.ref})` : "";
        return `${r}${i}${o}`;
      }
    } catch {
    }
  return /opencode|h9-saas-opencode|:\s*4096\b/i.test(e) ? "AI assistant is temporarily unavailable. Please try again in a moment." : e;
}
export {
  c as formatAssistantErrorMessage
};
